// PBI-866415 — Migración ADFS → Entra ID CIAM.
// angular-auth-oidc-client persiste tokens y el discovery document (well-known)
// por configId. Al mantener el mismo configId "ecoembes" tras cambiar el IDP,
// la librería reutiliza los tokens ADFS del localStorage al arrancar. Este
// módulo se ejecuta ANTES del bootstrap y purga esas claves.

const MIGRATION_KEY = 'authStorageMigration';
// PBI-866415 v2: purga más agresiva (cualquier clave con "ecoembes"/"oidc" en el
// nombre, más las que apunten a hostnames ADFS en su valor). Bumpear la versión
// fuerza que la purga vuelva a correr para navegadores donde v1 no cazó nada.
const MIGRATION_TARGET = 'ciam-v2';

function looksLikeOidcKey(key: string, value: string | null): boolean {
  if (!key) return false;
  const k = key.toLowerCase();
  // Cualquier clave del configId "ecoembes" que use la librería OIDC.
  if (k.includes('ecoembes')) return true;
  // Salvavidas: otras librerías/patrones OIDC estándar.
  if (k.includes('oidc') || k.includes('auth_') || k.startsWith('oauth')) return true;
  // Detecta por contenido: valores con hostnames ADFS de Ecoembes.
  if (!value) return false;
  return (
    value.includes('/adfs') ||
    value.includes('fspre.ecoembes.com') ||
    value.includes('fspro.ecoembes.com')
  );
}

export function runAuthStorageMigration(): void {
  try {
    const current = localStorage.getItem(MIGRATION_KEY);
    if (current === MIGRATION_TARGET) {
      return;
    }

    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key || key === MIGRATION_KEY) continue;
      const value = localStorage.getItem(key);
      if (looksLikeOidcKey(key, value)) {
        keysToRemove.push(key);
      }
    }

    keysToRemove.forEach((k) => localStorage.removeItem(k));
    sessionStorage.removeItem('oidcAuthorizeInFlight');
    localStorage.removeItem('sessionExpired');
    localStorage.setItem(MIGRATION_KEY, MIGRATION_TARGET);
  } catch (err) {
    console.error('[AUTH] Error en la migración del almacenamiento de autenticación', err);
  }
}

// Utilidad manual accesible desde DevTools:
//   __authResetStorage()  ← borra flag + purga + recarga
export function exposeManualReset(): void {
  try {
    (globalThis as { __authResetStorage?: () => void }).__authResetStorage = () => {
      localStorage.removeItem(MIGRATION_KEY);
      runAuthStorageMigration();
      location.reload();
    };
  } catch {
    // ignore
  }
}
